export const SET_TOAST_STATE = 'set_toast_state';
export const REMOVE_TOAST = 'set_toast';
